import { motion } from 'framer-motion';
import { FaCalendarCheck } from 'react-icons/fa';
import './StickyMobileCTA.css';

export default function StickyMobileCTA() {
  const scrollToContact = () => {
    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <motion.div
      className="sticky-cta"
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 2, type: 'spring', stiffness: 250, damping: 25 }}
    >
      <button className="sticky-cta__btn" onClick={scrollToContact}>
        <FaCalendarCheck /> Book Free Consultation
      </button>
    </motion.div>
  );
}
